import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useRef, useCallback, useMemo } from 'react';
import { Menu } from '../../components/Menu';
import { ANNOTATION_COLORS } from './ColorPicker';
const TOOL_LABELS = {
    box: 'Rectangle',
    circle: 'Ellipse',
    line: 'Line',
    arrow: 'Arrow',
    freeform: 'Freeform',
    text: 'Text',
    eraser: 'Eraser',
};
const DRAWING_TOOLS = ['box', 'circle', 'line', 'arrow', 'freeform', 'text'];
export const ToolbarOverflowMenu = React.memo(function ToolbarOverflowMenu({ overflowed, activeTool, onToolChange, activeColor, onColorChange, onUndo, onRedo, canUndo, canRedo, }) {
    const [isOpen, setIsOpen] = useState(false);
    const btnRef = useRef(null);
    const close = useCallback(() => {
        setIsOpen(false);
    }, []);
    const items = useMemo(() => {
        const result = [];
        if (overflowed.has('tool')) {
            const toolChildren = DRAWING_TOOLS.map((tool) => ({
                id: `tool-${tool}`,
                type: 'radio',
                label: TOOL_LABELS[tool],
                checked: tool === activeTool,
                onClick: () => {
                    onToolChange(tool);
                    setIsOpen(false);
                },
            }));
            result.push({
                id: 'tool-submenu',
                type: 'submenu',
                label: `Tool: ${TOOL_LABELS[activeTool]}`,
                children: toolChildren,
            });
        }
        if (overflowed.has('color')) {
            const colorChildren = ANNOTATION_COLORS.map((color) => ({
                id: `color-${color}`,
                type: 'custom',
                render: () => (_jsx("span", { className: `hekate-annotation-color-option${color === activeColor ? ' hekate-annotation-color-option--active' : ''}`, style: { backgroundColor: color }, "aria-label": color })),
                onClick: () => {
                    onColorChange(color);
                    setIsOpen(false);
                },
            }));
            result.push({
                id: 'color-submenu',
                type: 'submenu',
                label: 'Color',
                icon: (_jsx("span", { className: "hekate-annotation-overflow-color-swatch", style: { backgroundColor: activeColor } })),
                children: colorChildren,
                layout: 'grid',
                gridColumns: 5,
            });
        }
        if (overflowed.has('undo')) {
            result.push({
                id: 'undo',
                type: 'action',
                label: 'Undo',
                disabled: !canUndo,
                onClick: () => {
                    onUndo();
                    setIsOpen(false);
                },
            });
        }
        if (overflowed.has('redo')) {
            result.push({
                id: 'redo',
                type: 'action',
                label: 'Redo',
                disabled: !canRedo,
                onClick: () => {
                    onRedo();
                    setIsOpen(false);
                },
            });
        }
        return result;
    }, [overflowed, activeTool, activeColor, canUndo, canRedo, onToolChange, onColorChange, onUndo, onRedo]);
    if (overflowed.size === 0)
        return null;
    return (_jsxs("div", { className: "hekate-annotation-overflow-dropdown", style: { position: 'relative' }, children: [_jsx("button", { ref: btnRef, className: "hekate-annotation-toolbar-btn", onClick: () => setIsOpen((v) => !v), "aria-label": "More tools", "aria-expanded": isOpen, "data-tooltip": "More", type: "button", children: _jsx("span", { className: "hekate-annotation-overflow-dots", children: "\u22EE" }) }), _jsx(Menu, { items: items, isOpen: isOpen, onClose: close, ariaLabel: "More tools", triggerRef: btnRef })] }));
});
